uniform sampler2D uTexture;
uniform float uAlpha;
uniform vec2 uOffset;
varying vec2 vUv;

vec3 rgbShift(sampler2D textureimage, vec2 uv, vec2 offset ){
    vec2 uvR = clamp(uv + offset, 0.0, 1.0);
    vec2 uvGB = clamp(uv, 0.0, 1.0);

    float r = texture2D(textureimage, uvR).r;
    vec2 gb = texture2D(textureimage, uvGB).gb;

    return vec3(r, gb);
}

void main(){
    // vec3 color = texture2D(uTexture, vUv).rgb;
    vec3 color = rgbShift(uTexture, vUv, uOffset);
    color = clamp(color, 0.0, 1.0);
    gl_FragColor = vec4(color, clamp(uAlpha, 0.0, 1.0));
}
